import { apiClient } from '@/services/api/api';
import { logger } from '@/utils/logger/loggerInstance';

export interface PropertyRequest {
  id: string;
  groupId: string;
  buyerUserId: string;
  buyerName: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  latitude?: number;
  longitude?: number;
  fullAddress: string;
  status: 'pending' | 'approved' | 'rejected';
  // Absent (or 'group_access') = buyer already in this group asking their advisor
  // to add a property. 'ownership_claim' = self-serve user with no group of their
  // own claiming an address already managed by this group; approval grants
  // personal ownership, not group access.
  requestType?: 'group_access' | 'ownership_claim';
  resolvedBy?: string;
  propertyId?: string;
  createdAt: number;
  updatedAt: number;
}

export interface CreatePropertyRequestData {
  groupId: string;
  buyerName: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  latitude?: number;
  longitude?: number;
  fullAddress: string;
}

export const createPropertyRequest = async (
  data: CreatePropertyRequestData,
): Promise<{ request: PropertyRequest }> => {
  const url = '/property-requests';

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<{ request: PropertyRequest }>(url, data);

  return response.data;
};

export const getPropertyRequestsByGroup = async (
  groupId: string,
): Promise<{ requests: PropertyRequest[] }> => {
  const url = `/property-requests/group/${encodeURIComponent(groupId)}`;

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<{ requests: PropertyRequest[] }>(url);

  return response.data;
};

export const resolvePropertyRequest = async (
  id: string,
  action: 'approve' | 'reject',
): Promise<{ message: string; propertyId?: string; isExisting?: boolean }> => {
  const url = `/property-requests/${encodeURIComponent(id)}/resolve`;

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<{
    message: string;
    propertyId?: string;
    isExisting?: boolean;
  }>(url, { action });

  return response.data;
};
